import { render, staticRenderFns } from "./SpeedrunStatus.vue?vue&type=template&id=5faa7a14&scoped=true"
import script from "./SpeedrunStatus.vue?vue&type=script&lang=js"
export * from "./SpeedrunStatus.vue?vue&type=script&lang=js"
import style0 from "./SpeedrunStatus.vue?vue&type=style&index=0&id=5faa7a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa7a14",
  null
  
)

export default component.exports